import React, { useState, useEffect } from "react";
import Navbar from "../../../Shared/Navbar/Navbar";
import axios from "axios";
import DataTable from "../../../Layout/Table/TableLayout";
import { baseURL } from "../../../Apiservices/Api";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaEdit, FaTrash, FaCopy } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Templates = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [templatesList, setTemplatesList] = useState([]);
  const [editingId, setEditingId] = useState(null);
  
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("opportunity"); // ✅ TAB STATE
  


  useEffect(() => {
    fetchTemplates();
  }, []);

  // ✅ Fetch Templates
  const fetchTemplates = async () => {
    try {
      const response = await axios.get(`${baseURL}/api/opp-templates`);
      setTemplatesList(response.data);
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  };

  // ✅ Add / Update
  const handleAddOrUpdate = async () => {
    if (title.trim() === "" || body.trim() === "") return;

    try {
      if (editingId) {
        await axios.put(`${baseURL}/api/opp-templates/${editingId}`, {
          title,
          body,
        });
      } else {
        await axios.post(`${baseURL}/api/opp-templates`, {
          title,
          body,
        });
      }

      fetchTemplates();
      setTitle("");
      setBody("");
      setEditingId(null);
    } catch (error) {
      console.error("Error saving template:", error);
    }
  };

  // ✅ Edit
  const handleEdit = (template) => {
    setTitle(template.title);
    setBody(template.body);
    setEditingId(template.id);
  };

  // ✅ Cancel Edit
  const handleCancel = () => {
    setTitle("");
    setBody("");
    setEditingId(null);
  };

  // ✅ Delete
  const handleDelete = async (id) => {
    try {
      await axios.delete(`${baseURL}/api/opp-templates/${id}`);
      fetchTemplates();
    } catch (error) {
      console.error("Error deleting template:", error);
    }
  };

  // ✅ Copy Message
  const handleCopy = (template) => {
    const formatted = `*${template.title}*\n\n${template.body}`;
    navigator.clipboard.writeText(formatted);
    alert("Copied to clipboard!");
  };

  // ✅ Table Columns
  const columns = [
    { Header: "S.No", accessor: "serial" },
    { Header: "Title", accessor: "title" },
    { Header: "Body", accessor: "body" },
    {
      Header: "Actions",
      Cell: ({ row }) => (
        <div className="btn-group">
          <FaCopy
            style={{ color: "#28a745", cursor: "pointer", marginRight: "10px" }}
            title="Copy"
            onClick={() => handleCopy(row.original)}
          />

          <FaEdit
            style={{ color: "#ff9966", cursor: "pointer", marginRight: "10px" }}
            title="Edit"
            onClick={() => handleEdit(row.original)}
          />

          <FaTrash
            style={{ color: "#dc3545", cursor: "pointer" }}
            title="Delete"
            onClick={() => handleDelete(row.original.id)}
          />
        </div>
      ),
    },
  ];

  // ✅ Table Data
  const data = templatesList.map((t, index) => ({
    serial: index + 1,
    id: t.id,
    title: t.title,
    body: t.body,
  }));

  return (
    <div className="salesViewLeadsContainer">
      <Navbar onToggleSidebar={setCollapsed} />

      <div className={`salesViewLeads ${collapsed ? "collapsed" : ""}`}>

         {/* 🔥 TABS (SAME AS LEAD STATUS) */}
       <div className="payments-tabs">
  <button
    className={activeTab === "opportunity" ? "active" : ""}
    onClick={() => setActiveTab("opportunity")}
  >
    Opportunity WhatsApp Templates
  </button>

  <button
    className={activeTab === "lead" ? "active" : ""}
    onClick={() => {
      setActiveTab("lead");
      navigate("/a-whatsapp-templates");
    }}
  >
    Lead WhatsApp Templates
  </button>
</div>

        <h1>Opportunity WhatsApp Templates</h1>

       <div className="container mt-3">
  <div className="row">

    {/* ✅ LEFT SIDE - FORM */}
    <div className="col-md-6">

      <div className="mb-2">
        <input
          type="text"
          className="form-control"
          placeholder="Example: Hi {name}"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>

      <div className="mb-2">
        <textarea
          className="form-control"
          rows="5"
          placeholder="Example: Hi {name}, we sent details to {email}"
          value={body}
          onChange={(e) => setBody(e.target.value)}
        />
      </div>
      

      <div className="text-start">
        <button
          className="btn btn-success px-4 me-2"
          onClick={handleAddOrUpdate}
        >
          {editingId ? "Update" : "Add"}
        </button>

        {editingId && (
          <button
            className="btn btn-secondary px-4"
            onClick={handleCancel}
          >
            Cancel
          </button>
        )}
      </div>

    </div>

    {/* ✅ RIGHT SIDE - HELP BOX */}
   <div className="col-md-6">

  <div
    className="alert alert-info"
    style={{ fontSize: "14px", height: "100%" }}
  >
    <strong>How to use dynamic fields:</strong>
    <br />
    You can use:
    <br />
    <code>{"{name}"}</code>, <code>{"{email}"}</code>, <code>{"{phone}"}</code>,{" "}
    <code>{"{leadid}"}</code>, <code>{"{destination}"}</code>, <code>{"{city}"}</code>

    <hr style={{ margin: "8px 0" }} />

    <strong>Example Template:</strong>
    <br />
    Hi {"{name}"}, we have sent the quotation to {"{email}"}.

    <br /><br />

    <strong>Output (Auto-filled):</strong>
    <br />
    Hi Ravi, we have sent the quotation to ravi@example.com

  </div>

</div>

  </div>
</div>

        {/* ✅ TABLE */}
        <div className="mt-4">
          <DataTable columns={columns} data={data} />
        </div>
      </div>
    </div>
  );
};

export default Templates;